<script lang="ts">
  import { toasts } from '../../lib/state/toasts.svelte.js'
</script>

<div class="host" role="status" aria-live="polite">
  {#if toasts.current}
    {#key toasts.current.id}
      <div class="toast" class:error={toasts.current.tone === 'error'}>
        <span class="message">{toasts.current.message}</span>
        {#if toasts.current.action}
          <button onclick={() => toasts.runAction()}>{toasts.current.action.label}</button>
        {/if}
      </div>
    {/key}
  {/if}
</div>

<style>
  .host {
    position: fixed;
    left: 50%;
    bottom: calc(var(--space-4) + env(safe-area-inset-bottom));
    z-index: 60;
    transform: translateX(-50%);
    width: min(520px, calc(100vw - var(--space-4) * 2));
    pointer-events: none;
  }
  .toast {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
    border-radius: var(--radius);
    background: var(--fg);
    color: var(--bg);
    box-shadow: var(--shadow-2);
    pointer-events: auto;
    animation: slide-up var(--dur) var(--ease);
  }
  .toast.error {
    background: var(--danger);
    color: #fff;
  }
  .message {
    flex: 1;
    font-size: 15px;
  }
  button {
    min-height: 36px;
    padding: 0 var(--space-3);
    border: none;
    border-radius: var(--radius-sm);
    background: rgb(255 255 255 / 15%);
    color: inherit;
    font-weight: 600;
  }
  button:hover {
    background: rgb(255 255 255 / 25%);
  }
  @keyframes slide-up {
    from {
      transform: translateY(12px);
      opacity: 0;
    }
  }
</style>
